<div class="he">
    <div>
      <a href="/company/solde">
        <img class="w-20 ml-5" src="./assets/logo.svg" alt="">
        </a>
    </div>
   
    <!-- Button to toggle the modal -->
  <button 
    type="button"
    class="btn"
    (click)="openModal()">
    + Nouvelle commande
  </button>
     
 </div>
<!-- Modal Nouvelle commande (Flowbite) -->
<div id="{{commandeModalId}}" tabindex="-1" aria-hidden="true" class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
  <div class="nc-wrap">
    <div class="nc-panel">

      <div class="nc-head">
        <div>
          <h3 class="nc-title">Nouvelle commande</h3>
          <p class="nc-sub">Rechargez le solde de votre entreprise pour distribuer des titres à vos bénéficiaires.</p>
        </div>
        <button type="button" class="nc-close" (click)="closeModal()" aria-label="Fermer">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
      </div>

      <form [formGroup]="ticketOrderForm" (ngSubmit)="onSubmit()">
        <div class="nc-body">

          <!-- 1. Type de recharge -->
          <div class="nc-field">
            <span class="nc-label">Type de recharge *</span>
            <div class="nc-types" role="radiogroup">
              <button
                *ngFor="let ticket of tickets"
                type="button"
                role="radio"
                class="nc-type"
                [class.is-selected]="ticketOrderForm.get('ticket')?.value == ticket.id"
                [attr.aria-checked]="ticketOrderForm.get('ticket')?.value == ticket.id"
                (click)="selectTicket(ticket.id)">
                <span class="nc-radio"></span>
                <span class="nc-type-label">{{ ticket.label }}</span>
              </button>
            </div>
            <p *ngIf="!tickets.length" class="nc-empty">Aucun type de recharge disponible.</p>
            <div *ngIf="ticketOrderForm.get('ticket')?.invalid && ticketOrderForm.get('ticket')?.touched" class="nc-error">
              Choisissez un type de recharge.
            </div>
          </div>

          <!-- 2. Quantité / montant -->
          <div class="nc-field" *ngIf="ticketOrderForm.get('ticket')?.value">
            <label for="nc-amount" class="nc-label">{{ amountLabel }} *</label>
            <div class="nc-input-wrap">
              <input
                id="nc-amount"
                type="number"
                min="1"
                formControlName="amount"
                class="nc-input"
                [placeholder]="isTicketRestaurantSelected ? 'Ex : 100' : 'Ex : 50000'" />
              <span class="nc-suffix">{{ isTicketRestaurantSelected ? 'tickets' : 'XOF' }}</span>
            </div>
            <div *ngIf="ticketOrderForm.get('amount')?.invalid && (ticketOrderForm.get('amount')?.dirty || ticketOrderForm.get('amount')?.touched)" class="nc-error">
              <span *ngIf="ticketOrderForm.get('amount')?.errors?.['required']">{{ amountLabel }} est requis.</span>
              <span *ngIf="ticketOrderForm.get('amount')?.errors?.['min']">La valeur doit être supérieure ou égale à 1.</span>
              <span *ngIf="ticketOrderForm.get('amount')?.errors?.['pattern']">Entrez un nombre entier.</span>
            </div>
          </div>

          <!-- 3. Récapitulatif -->
          <div class="nc-recap" *ngIf="ticketOrderForm.get('ticket')?.value && ticketOrderForm.get('amount')?.valid">
            <ng-container *ngIf="isTicketRestaurantSelected; else recapAmount">
              <div class="nc-recap-row">
                <span>Valeur d'un ticket</span>
                <span>{{ formatXof(ticketAmount) }}</span>
              </div>
              <div class="nc-recap-row">
                <span>Nombre de tickets</span>
                <span>× {{ ticketOrderForm.get('amount')?.value }}</span>
              </div>
              <div class="nc-recap-total">
                <span>Montant total</span>
                <strong>{{ formatXof(calculatedAmount) }}</strong>
              </div>
            </ng-container>
            <ng-template #recapAmount>
              <div class="nc-recap-total">
                <span>Montant total</span>
                <strong>{{ formatXof(ticketOrderForm.get('amount')?.value) }}</strong>
              </div>
            </ng-template>
          </div>
        </div>

        <div class="nc-foot">
          <button type="button" class="nc-btn nc-btn--secondary" (click)="closeModal()">Annuler</button>
          <button type="submit" class="nc-btn nc-btn--primary" [disabled]="!ticketOrderForm.valid">Valider la commande</button>
        </div>
      </form>
    </div>
  </div>
</div>

   <div class="card flex justify-content-center">
     <p-toast />
 </div>